import { createLucideIcon } from 'lucide-react';
export const EmailOpenIcon = createLucideIcon('', [
  [
    'path',
    {
      d: 'M21 9.3125L12 14.5625L3 9.3125',
      key: '1kamnu',
    },
  ],
  [
    'path',
    {
      d: 'M21 9.3125V19.0625C21 19.2614 20.921 19.4522 20.7803 19.5928C20.6397 19.7335 20.4489 19.8125 20.25 19.8125H3.75C3.55109 19.8125 3.36032 19.7335 3.21967 19.5928C3.07902 19.4522 3 19.2614 3 19.0625V9.3125L12 3.3125L21 9.3125Z',
      key: '90p1xg',
    },
  ],
]);
